"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});Object.defineProperty(exports,"getTarget",{enumerable:true,get:function get(){return _getTarget["default"];}});Object.defineProperty(exports,"isDomElement",{enumerable:true,get:function get(){return _isDomElement["default"];}});var _getTarget=_interopRequireDefault(require("./getTarget"));var _isDomElement=_interopRequireDefault(require("./isDomElement"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rainbow-modules/hooks/lib/helpers/index.js
// module id = b4LS
// module chunks = 0